export const CARDS_ROUTE = 'karty';
